import { jsx as _jsx } from "react/jsx-runtime";
import { format, NumberKind } from '../../helpers/numberUtils';
import CountUp from 'react-countup';
const CurrencyStatistic = (props) => {
    return (_jsx(CountUp, { end: props.amount, formattingFn: amount => format(amount, { type: NumberKind.Currency }) }));
};
export default CurrencyStatistic;
